import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createOrganisation, organisationsQueryKeys } from '@api/organisations';
import type { ApiOrganisation } from '@api/organisations';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from '../useTranslation';

interface UseCreateOrganisationOptions {
  onSuccess?: (organisation: ApiOrganisation) => void;
}

// Create-organisation mutation (GRAIN-2237). Mirrors useCreateContact;
// invalidation + toast live here so callers only handle UI (closing the modal).
export function useCreateOrganisation(options?: UseCreateOrganisationOptions) {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: createOrganisation,
    onSuccess: (organisation) => {
      queryClient.invalidateQueries({ queryKey: organisationsQueryKeys.lists() });
      // Distinct from create_modal.success — that key is "Contact created" in
      // the create-order island (which also creates customers). Fallback keeps
      // the copy correct on any island that hasn't scoped the key.
      toast({ description: t('create_modal.organisation_success', 'Organisation created') });
      options?.onSuccess?.(organisation);
    },
  });
}
